import React from "react";
import paths from "@icarius-router/paths";
import CommonPage from "@icarius-common/commonPage";
import useIssueSummary from "./useIssueSummary";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import MatrixDialog from "./dialogs/matrixDialog";
import useTemplates from "@icarius-common/templates/components/useTemplates";
import CreateTemplateDialog from "@icarius-common/templates/components/createTemplateDialog";
import TemplatesHeader from "@icarius-common/templates/components/templatesHeader";
import { getLocalizedString } from "@icarius-localization/strings";
import useFixedFilters from "@icarius-common/fixedFilters";

const IssueSummary = ({ code, name, handleGoBack, history }) => {
  const title = `${getLocalizedString("issueSummary")} ${name ? `- ${name}` : ''}`;

  const comesFromOtherPage = Boolean(code);

  const {
    isLoading,
    data,
    selectedRow,
    matrixData,
    yearList,
    issueList,
    matrixDialogIsOpen,
    handleRowClick,
    handleOpenMatrixDialog,
    handleCloseMatrixDialog,
    handleOpenCalendarDialog,
  } = useIssueSummary(code);

  const {
    user,
    templates,
    selectedTemplate,
    isLoadingTemplates,
    createTemplateDialogIsOpen,
    getRole,
    handleCreateTemplate,
    handleImportTemplates,
    handleExportTemplates,
    handleSelectTemplateAndUpdateGrid,
    handleOpenCreateTemplateDialog,
    handleOpenUpdateTemplateDialog,
    handleOpenDeleteTemplateDialog,
    handleCloseCreateTemplateDialog,
  } = useTemplates('ISSUE_SUMMARY');

  const {
    hasFixedFilters,
    toggleFixedFilters,
  } = useFixedFilters(title);

  const selectInput = (gridRef) => (
    <TemplatesHeader
      gridRef={gridRef}
      user={user}
      templates={templates}
      selectedTemplate={selectedTemplate}
      getRole={getRole}
      handleImportTemplates={handleImportTemplates}
      handleExportTemplates={handleExportTemplates}
      handleOpenCreateTemplateDialog={handleOpenCreateTemplateDialog}
      handleOpenDeleteTemplateDialog={handleOpenDeleteTemplateDialog}
      handleOpenUpdateTemplateDialog={handleOpenUpdateTemplateDialog}
      handleSelectTemplateAndUpdateGrid={handleSelectTemplateAndUpdateGrid}
    />
  )

  const child = (gridRef) =>
    <>
      {
        createTemplateDialogIsOpen &&
        <CreateTemplateDialog
          open={createTemplateDialogIsOpen}
          level={user.level}
          handleCreateTemplate={(role, name) => handleCreateTemplate(gridRef, role, name)}
          handleCloseDialog={handleCloseCreateTemplateDialog}
        />
      }
      {
        matrixDialogIsOpen &&
        <MatrixDialog
          open={matrixDialogIsOpen}
          handleClose={handleCloseMatrixDialog}
          data={matrixData}
          yearList={yearList}
          issueList={issueList}
          selectedRow={selectedRow}
        />
      }
    </>

  const calendarItem = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("viewCalendar")}
      onClick={() => handleOpenCalendarDialog(gridRef)}
      type={"calendar"}
    />
  )

  const matrixItem = (gridRef) =>
    <CustomIconButton
      title={getLocalizedString("issueMatrix")}
      onClick={() => handleOpenMatrixDialog(gridRef)}
    />

  const goBackItem = () =>
    <CustomIconButton
      title={getLocalizedString("goBack")}
      onClick={() => Boolean(handleGoBack) ? handleGoBack() : history.push(paths.issueManagementScreenSelector)}
      type={"goBack"}
    />

  const filtersItem = (gridRef) =>
    <CustomIconButton
      title={hasFixedFilters ? getLocalizedString("removeFixedFilters") : getLocalizedString("setFixedFilters")}
      onClick={() => toggleFixedFilters(gridRef, Boolean(selectedTemplate))}
      type={"fixedFilter"}
      isSelected={hasFixedFilters}
    />

  return (
    <CommonPage
      isLoading={isLoading || isLoadingTemplates}
      title={title}
      gridTitle={title}
      columnDefPage={paths.issueSummary}
      rowData={data}
      handleRowClick={!comesFromOtherPage && handleRowClick}
      customHeader={!comesFromOtherPage && selectInput}
      menuItems={comesFromOtherPage ? [goBackItem, matrixItem, filtersItem] : [goBackItem, calendarItem, matrixItem, filtersItem]}
      hasExpand
      hasHelp
      codeFieldName={'Código de empleado'}
      hasFixedFilters
    >
      {child}
    </CommonPage>
  )
}

export default IssueSummary;